import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    openId: null,
    raxwUser: null,
    env: null
  },
  mutations: {
    SET_OPEN_ID: (state, openId) => {
      state.openId = openId;
    },
    SET_RAXW_USER: (state, raxwUser) => {
      state.raxwUser = raxwUser;
    },
    SET_ENV: (state, env) => {
      state.env = env;
    }
  },
  actions: {},
  modules: {}
});
